import Calendar from "images/ic_calendar.svg";
import { useAppSelector } from "../../../../../util/store-types";

export default function ReservePromoBanner() {
  const cmsContent = useAppSelector(state => state.smartComponentState?.PDPContent?.data);

  if (!cmsContent?.reserve || !cmsContent?.reserve?.promoCode) {
    return null;
  }

  const hed = cmsContent?.reserve?.hed;
  const copy = cmsContent?.reserve?.copy;
  const copyTwo = cmsContent?.reserve?.copyTwo;
  const promoCode = cmsContent?.reserve?.promoCode;

  return (
    <div className="p-3 text-sm rounded-md mb-6 bg-wine100" data-test-id="subscription-promo-banner">
      <div className="flex items-center mb-1">
        <Calendar />
        <p className="ml-2 font-semibold">{hed}</p>
      </div>
      <div className="ml-8">
        <span>{copy} </span>
        <span className="font-semibold">{promoCode} </span>
        <span>{copyTwo}</span>
      </div>
    </div>
  );
}
